<template>
  <div class="studio-resource-option" v-if="chapterResource">
    <v-layout class="full-height" row>
      <v-flex class="flex-column-justify-center" xs1 @click="handleSelection">
        <svg-icon width="32" height="32" :fileName="chapterResource.icon" :assetLocation="getAssetLocation()" />
      </v-flex>
      <v-flex class="flex-column-justify-center pointer" pl-3 xs10 @click="handleSelection">
        <div class="studio-resource-option__title text-overflow-ellipse">{{ chapterResource.title }}</div>
        <div class="studio-resource-option__subTitle text-overflow-ellipse">{{ chapterResource.subTitle }}</div>
      </v-flex>
      <v-flex class="flex-column-justify-center text-right" xs1>
        <v-icon v-if="isFavorite" size="24" class="ypo_brand_blue_color pointer" @click="handleFavorite">fa-solid fa-heart</v-icon>
        <v-icon v-else size="24" class="ypo_cta_blue_color pointer" @click="handleFavorite">fa-regular fa-heart</v-icon>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import SvgIcon from "@/components/NetworkPage/SvgIcon.vue";

export default {
  name: 'ChapterStudioResource',
  props: {
    chapterResource: {
      type: Object,
      require: true,
    },
    handleFavoriteClick: {
      type: Function,
      required: true,
    },
    isFavorite: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  components: {
    SvgIcon,
  },
  methods: {
    handleSelection() {
      let target = '_self';
      if (this.chapterResource.isExternalLink) target = '_blank';
      window.open(this.chapterResource.url || '', target);
    },
    handleFavorite() {
      this.handleFavoriteClick(this.chapterResource, !this.isFavorite);
    },
    getAssetLocation() {
      return 'chapterStudioSvgImg' ;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../common/styles/_colors.scss";
@import "../../common/styles/_responsive.scss";
@import "../../common/styles/_commonClasses.scss";

.studio-resource-option {
  height: 56px;
  background: $ypo-cta-light-background;
  border-radius: 8px;
  padding: 8px 15px;

  &:hover {
    background-color: $ypo-cta-light;
  }

  &__title {
    font-size: 17px;
    font-weight: 400;
    line-height: 18px;
    color: $ypo-brand-blue;

    &--padded {
      margin-top: 7px;
    }
  }

  &__subTitle {
    font-size: 13px;
    font-weight: 400;
    line-height: 14px;
    color: $ypo-dim-gray;
  }
}
</style>
